import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

const MakePaymentTab = ({ partner }) => {
  const [payments, setPayments] = useState([]);
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("Bank Transfer");
  const [reference, setReference] = useState("");
  const [purpose, setPurpose] = useState("");

  const nextId = useMemo(
    () => (payments.length ? Math.max(...payments.map((p) => p.id)) + 1 : 1),
    [payments]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || !purpose) return;

    const newPayment = {
      id: nextId,
      date: new Date().toISOString().slice(0, 10),
      amount: Number(amount),
      method,
      reference: reference || "-",
      purpose,
      status: "pending",
    };

    setPayments([newPayment, ...payments]);
    setAmount("");
    setMethod("Bank Transfer");
    setReference("");
    setPurpose("");
  };

  return (
    <div className="space-y-6">
      <div className="border rounded-lg p-4 bg-gray-50">
        <h3 className="text-sm font-semibold text-gray-800 mb-3">
          Make Payment {partner?.name ? `to ${partner.name}` : ""}
        </h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs text-gray-600 mb-1">Amount (Rs.)</label>
            <input
              type="number"
              min="0"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
              placeholder="Enter amount"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">Method</label>
            <select
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
            >
              <option>Bank Transfer</option>
              <option>UPI</option>
              <option>Cash</option>
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">Reference</label>
            <input
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
              placeholder="PAYOUT-XXX"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">Purpose</label>
            <input
              type="text"
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
              placeholder="Job payment or reason"
            />
          </div>
          <div className="md:col-span-4">
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white text-sm rounded"
            >
              Create Payment
            </button>
          </div>
        </form>
      </div>

      <div className="overflow-x-auto border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-2 text-left">Date</th>
              <th className="px-4 py-2 text-left">Purpose</th>
              <th className="px-4 py-2 text-left">Amount (Rs.)</th>
              <th className="px-4 py-2 text-left">Method</th>
              <th className="px-4 py-2 text-left">Reference</th>
              <th className="px-4 py-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id} className="border-b">
                <td className="px-4 py-2">
                  {new Date(payment.date).toLocaleDateString()}
                </td>
                <td className="px-4 py-2">{payment.purpose}</td>
                <td className="px-4 py-2 font-semibold">
                  Rs. {payment.amount}
                </td>
                <td className="px-4 py-2">{payment.method}</td>
                <td className="px-4 py-2 font-medium">{payment.reference}</td>
                <td className="px-4 py-2">
                  <span
                    className={`text-xs font-semibold px-2 py-1 rounded-full ${
                      payment.status === "completed"
                        ? "bg-green-100 text-green-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {payment.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {payments.length === 0 && (
          <div className="p-4 text-gray-500">
            No payments created for this partner.
          </div>
        )}
      </div>
    </div>
  );
};

MakePaymentTab.propTypes = {
  partner: PropTypes.any,
};

export default MakePaymentTab;
